import { createContext, useContext, useEffect, useState } from "react";
import { useAuth0 } from "../components/auth/DevAuth0Provider";
import { jwtDecode } from "jwt-decode";


const AuthUserContext = createContext(null);

export const AuthUserProvider = ({ children }) => {
  const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [profile, setProfile] = useState({});

  useEffect(() => {
    if (isAuthenticated && user) {

      const namespace = process.env.REACT_APP_AUTH0_NAMESPACE || 'https://helios-core.com/claims';
      const roles = user[`${namespace}/roles`] || [];

      // Debug: Log the user object to see what claims are available
      // console.log('Auth0 User Object:', user);
      // console.log('Looking for roles at:', `${namespace}/roles`);
      // console.log('Found roles:', roles);

      // Debug: Check all possible role locations and organization info
      // console.log('🔍 Debug - All user properties:', Object.keys(user));
      // console.log('🔍 Debug - Namespace roles:', user[`${namespace}/roles`]);
      // console.log('🔍 Debug - Direct roles:', user.roles);
      // console.log('🔍 Debug - Authorization:', user.authorization);
      // console.log('🔍 Debug - App metadata:', user.app_metadata);
      // console.log('🔍 Debug - User metadata:', user.user_metadata);
      // console.log('🔍 Debug - Organization info:', {
      //   org_id: user.org_id,
      //   org_name: user.org_name,
      //   organizations: user.organizations
      // });

      // Extract customer information from Auth0 custom claims or app_metadata
      // For client_admin users, also check organization-related fields
      let customerId = user[`${namespace}/customer_id`] ||
                      user.app_metadata?.customer_id ||
                      user[`${namespace}/org_name`] ||
                      user.app_metadata?.org_name ||
                      user["https://helios.dev/tenant_id"] ||
                      user.org_name;

      // If still no customer ID, check organizations array for client_admin users
      if (!customerId && user.organizations && Array.isArray(user.organizations) && user.organizations.length > 0) {
        // For client_admin users, use the first organization's name as customer ID
        const firstOrg = user.organizations[0];
        customerId = firstOrg.name?.toLowerCase() || firstOrg.display_name?.toLowerCase();
        // console.log('🔍 AuthUserContext: Using organization name as customer ID:', customerId, 'from org:', firstOrg);
      }

      // Final fallback
      if (!customerId) {
        customerId = 'unknown';
      }

      const clientId = user[`${namespace}/client_id`] ||
                      user.app_metadata?.client_id ||
                      customerId;
      const organizationId = user[`${namespace}/organization_id`] ||
                            user.app_metadata?.organization_id ||
                            user[`${namespace}/org_id`] ||
                            user.org_id;
      const chatEndpoint = user[`${namespace}/chat_endpoint`] ||
                          user.app_metadata?.chat_endpoint ||
                          `/${clientId}/chat`;

      // console.log('🔍 AuthUserContext: Customer extraction details:', {
      //   customerId,
      //   clientId,
      //   organizationId,
      //   chatEndpoint,
      //   app_metadata: user.app_metadata,
      //   custom_claims: {
      //     customer_id: user[`${namespace}/customer_id`],
      //     client_id: user[`${namespace}/client_id`],
      //     organization_id: user[`${namespace}/organization_id`],
      //     org_name: user[`${namespace}/org_name`],
      //     org_id: user[`${namespace}/org_id`]
      //   },
      //   direct_org_fields: {
      //     org_name: user.org_name,
      //     org_id: user.org_id
      //   },
      //   organizations_array: user.organizations,
      //   roles: roles
      // });

      // Check if user is Helios admin
      const isHeliosAdmin = roles.includes('helios_admin');

      setProfile({
        name: user.name,
        email: user.email,
        picture: user.picture,
        // Legacy support
        tenantId: customerId,
        role: roles.length > 0 ? roles[0] : 'Guest',
        // New customer-specific fields
        customerId,
        clientId,
        organizationId,
        chatEndpoint,
        isHeliosAdmin,
        roles,
        // Full user object for debugging
        _raw: user
      });
    }
  }, [isAuthenticated, user]);

  // Verifying JWT - removed automatic token check to prevent loops

  return (
    <AuthUserContext.Provider value={profile}>
      {children}
    </AuthUserContext.Provider>
  );
};

export const useAuthUser = () => useContext(AuthUserContext);